import { UserFacingError } from './errors'

export class PlanChangeAmountMismatchError extends UserFacingError {
  constructor() {
    super(
      'The price changed while you were reviewing this. Check the updated amount below, then confirm again.',
    )
    this.name = 'PlanChangeAmountMismatchError'
  }
}
